<template>
    <div class="landlord-login-comp">
        <div class="title">
            個人房東登入
        </div>
        <div class="landlord-wrap">
            <label for="phone" class="button-font input-label phone-label">
                手機號碼
                <span v-show="error.landlord.phoneErr" class="error-with-title">{{error.landlord.phoneErr}}</span>
            </label>
            <div class="input-group select-list phone" :class="{error: error.landlord.phoneErr}">
                <div class="input-group-prepend" @click="clickEvent">
                    <span data-id="886" class="input-group-text" > 
                        <!-- <img class="country-img" src="@/assets/img/flag/TW.png" alt=""> -->
                        +886
                        <img class="dropdown-img" src="@/assets/img/icon/arrow_down_black.svg" alt="">
                    </span>
                    <ul class="religion" v-if="dropDownShow">
                        <li>
                            <img class="country-img" src="@/assets/img/flag/TW.png" alt="">
                            +886
                        </li>
                    </ul>
                </div>
                <input class="phone-num" required name="phone" placeholder="請輸入手機號碼" type="text" v-bind:class="{ error: error.landlord.phoneErr, confirm: landlord.phone }" v-model="landlord.phone">
                <img class="cancel-img" v-show="landlord.phone" @click="clearAccount" src="@/assets/img/icon/input_clear_all.svg" alt="">
            </div>
            <div class="verify-code">
                <label for="verifyCode" class="button-font input-label" style="width: 176px;">
                    驗證碼
                    <span v-show="error.landlord.verifyCodeErr" class="error-with-title">{{error.landlord.verifyCodeErr}}</span>
                </label>
                <div class="group">
                    <input class="landing-input" required name="verifyCode" placeholder="請輸入手機驗證碼" type="text" v-bind:class="{confirm: landlord.verifyCode, error: error.landlord.verifyCodeErr}" v-model="landlord.verifyCode">
                    <div v-if="timer==0" class="count-down-btn" @click="landlordRegister(), timer = 60, countDown(), $analytics.logEvent('登入頁_送出取得驗證碼', { screen_name: '登入頁_送出取得驗證碼'})" >獲取驗證碼</div>
                    <div v-else class="count-down-btn">簡訊已發送 {{timer}}</div>
                </div>
            </div>
            <div class="default-button" @click="landlordLogin(), $analytics.logEvent('登入頁_送出登入', { screen_name: '登入頁_送出登入'})">立即註冊 / 登入</div>
            <span class="private">登入及註冊即同意 <router-link :to="{ name: 'privacyPolicy'}">隱私權政策</router-link> | <router-link :to="{ name: 'userTerms'}">會員條款</router-link></span>
        </div>
    </div>
</template>

<script>
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    data () {
        return{
            landlord: {
                nationalityCode: '886',
                phone: null,
                verifyCode: null,
            },
            error: {
                landlord: {
                    phoneErr: null,
                    verifyCodeErr: null,
                },
            },
            dropDownShow: 0,
            timer: 0,
        }
    },
    mounted () {
        // this.$analytics.logEvent('統計分流＿房東', { screen_name: '統計分流＿房東'})
        // this.$analyticsBiz.logEvent('統計分流＿企業', { screen_name: '統計分流＿企業'})
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            if( el.contains(e.target) != true){
                _this.dropUp();
            }
        })
    },
    watch: {
        'landlord.phone': function (val) {
            let phoneReg = /^09[0-9]{8}$/;
            if( val.length > 0 ){
                if( this.landlord.nationalityCode == '886'){
                    let phone = this.phoneFormatTw(val)
                   if(!phoneReg.test(phone)) {
                        this.error.landlord.phoneErr = '格式錯誤';
                    }else{
                        this.error.landlord.phoneErr = '';
                    }
                }
            }else{
                this.error.landlord.phoneErr = '';
            }
        },
        'landlord.verifyCode': function (val) {
            // if(val.length > 0){
            this.error.landlord.verifyCodeErr = '';
            // }else{

            // }
        },
    },
    methods: {
        landlordRegister: function () {
            let account = this.phoneFormatTw(this.landlord.phone)
            let nationality_code = this.landlord.nationalityCode

            let data = {
                account,
                nationality_code
            }
            this.$store.dispatch('landlordRegister',data).catch(err => {
                let alarm = {
                    status: true,
                    title: '系統發生未預期錯誤，請再試一次',
                    description: null,
                    type: 'error'
                }
                this.$store.dispatch('setAlarmStatus', alarm)
            })
        },
        landlordLogin: function () {
            if(this.mobileRedirect()){
                let account = this.phoneFormatTw(this.landlord.phone)
                let verification_code = this.landlord.verifyCode
                let nationality_code = this.landlord.nationalityCode
                let login_from = 'WEB_LANDLORD'
                let data = {account, verification_code, nationality_code, login_from}
                this.$store.dispatch('landlordLogin',data)
                .then(() => window.location = "/landlord/housestatus/home")
                .catch(err => {
                    if(err.data.errorCode === 221003){
                        this.error.landlord.verifyCodeErr = err.data.errorMsg
                    }else if(err.data.errorCode === 221001){
                        this.error.landlord.phoneErr = err.data.errorMsg
                    }else{
                        let alarm = {
                            status: true,
                            title: err.data.errorMsg,
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                    
                })
            }
        },
        phoneFormatTw: function (phone) {
            if(phone.substr(0, 1) == '9' && phone.length == 9){
                return phone = '0' + phone;
            }else{
                return phone;
            }
        },
        clearAccount: function () {
            this.landlord.phone = null
            this.error.landlord.phoneErr = null
        },
        dropDown: function () {
            this.dropDownShow = 1;
        },
        dropUp: function () {
            this.dropDownShow = 0;
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
            }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
                this.dropDown()
            }
        },
        countDown: function () {
            var _self = this
            if (this.timer != 0){
                this.timer--;
                setTimeout(function() {
                    _self.countDown()
                },
                1000)
            }
        },
        mobileRedirect: function () {
            let _self =this

            if(_self.system == 'pc'){
                return true
            }else{
                document.location = constant.fetuzbookLandlordSchema+'://';
                var time = (new Date()).getTime();
                setTimeout(function(){
                    setTimeout(function(){ // <-- start new thread after activation
                        var now = (new Date()).getTime();
                        if((now - time)<400) {
                            if(confirm('你未安裝飛豬管家，將引導AppStore')){
                                window.open(_self.appUrl.landlord)
                            }
                        }
                    }, 10); // <-- start new thread after activation
                }, 300);
            }
        },
    },
    computed: {
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
        })
    },
}
</script>

<style lang="scss" scoped>
    .landlord-login-comp{
        position: relative;
        width: 368px;
        height: 462px;
        padding: 45px 30px 49px;
        border-radius: 16px;
        box-sizing: border-box;
        box-shadow: 2px 15px 40px 0 rgba(41, 38, 37, 0.2), 0 8px 16px 0 rgba(140, 140, 140, 0.37);
        background-color: #ffffff;
        .title{
            font-size: 24px;
            font-weight: 500;
            margin-bottom: 30px;
        }
        .phone-label{
            font-size: 16px;
        }
        .landlord-wrap{
            .phone{
                position: relative;
                width: 100%;
                margin-bottom: 24px;
                .input-group-prepend{
                    .religion{
                        margin-top: 2px;
                        width: 310px;
                        >li{
                            img{
                                margin-right: 8px;
                            }
                        }
                    }
                }
                input{
                    height: 30px;
                    font-size: 16px;
                    &::placeholder {
                        /* Chrome, Firefox, Opera, Safari 10.1+ */
                        color: #c5c2c1;
                        letter-spacing: 0.16px;
                        font-size: 16px;
                    }
                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: #a8a5a4;
                        letter-spacing: 0.16px;
                        font-size: 16px;
                    }
                    
                    &::-ms-input-placeholder {
                        /* Microsoft Edge */
                        color: #a8a5a4;
                        letter-spacing: 0.16px;
                        font-size: 16px;
                    }
                }
                .cancel-img{
                    position: absolute;
                    right: 10px;
                    cursor: pointer;
                }
            }
            .verify-code{
                margin-bottom: 50px;
                .group{
                    position: relative;
                    display: flex;
                    align-items: center;
                    input{
                        width: 178px;
                        margin-right: 12px;
                        font-size: 16px;
                        // height: 16px;
                        
                    }
                    .border-button-black{
                        width: 118px;
                        height: 18px;
                        line-height: 19px;
                    }
                    .count-down-btn{
                        cursor: pointer;
                        width: 118px;
                        height: 48px;
                        border-radius: 8px;
                        background-color: #fff9f1;
                        color: #eb7859;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 500;
                    }
                }
            }
            .default-button{
                border-radius: 8px;
                height: 48px;
            }
            .private{
                display: block;
                text-align: center;
                margin-top: 16px;
                margin-bottom: 6px;
                font-size: 12px;
                font-weight: 300;
                color: #676362;
                margin-bottom: 34px;
                a{
                    margin: 0 10px;
                    text-decoration: underline;
                }
            }
        }
    }
    @media screen and (max-height: 800px) {
        .landlord-login-comp{
            bottom: 34px;
            width: 325px;
            height: 408px;
            padding: 38px 24px 44px;
            .title{
                font-size: 22px;
                margin-bottom: 27px;
            }
            .phone-label{
                font-size: 14px;
            }
            .landlord-wrap{
                .phone{
                    position: relative;
                    width: 100%;
                    height: 42px;
                    margin-bottom: 24px;
                    .input-group-prepend{
                        .religion{
                            width: 278px;
                        }
                    }
                    input{
                        height: 30px;
                        font-size: 14px;
                        &::placeholder {
                            font-size: 14px;
                        }
                        &:-ms-input-placeholder {
                            font-size: 14px;
                        }
                        
                        &::-ms-input-placeholder {
                            font-size: 14px;
                        }
                    }
                    .cancel-img{
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                    }
                }
                .verify-code{
                    margin-bottom: 44px;
                    .group{
                        position: relative;
                        display: flex;
                        align-items: center;
                        input{
                            width: 150px;
                            margin-right: 11px;
                            font-size: 14px;
                            height: 42px;
                            &::placeholder {
                                font-size: 14px;
                            }
                            &:-ms-input-placeholder {
                                font-size: 14px;
                            }
                            
                            &::-ms-input-placeholder {
                                font-size: 14px;
                            }
                        }
                        .border-button-black{
                            width: 118px;
                            height: 18px;
                            line-height: 19px;
                        }
                        .count-down-btn{
                            width: 111px;
                            height: 42px;
                        }
                    }
                }
                .default-button{
                    height: 42px;
                }
            }
        }
    }
    @media screen and (max-width: 800px) {
        .landlord-login-comp{
            box-shadow: unset;
            border-radius: 0;
            .title{
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 26px;
                text-align: center;
            }
            .phone-label{
                font-size: 16px;
            }
            .landlord-wrap{
                .phone{
                    position: relative;
                    width: 100%;
                    margin-bottom: 24px;
                    input{
                        height: 30px;
                        font-size: 16px;
                        &::placeholder {
                            /* Chrome, Firefox, Opera, Safari 10.1+ */
                            color: #c5c2c1;
                            letter-spacing: 0.16px;
                            font-size: 16px;
                        }
                        &:-ms-input-placeholder {
                            /* Internet Explorer 10-11 */
                            color: #a8a5a4;
                            letter-spacing: 0.16px;
                            font-size: 16px;
                        }
                        
                        &::-ms-input-placeholder {
                            /* Microsoft Edge */
                            color: #a8a5a4;
                            letter-spacing: 0.16px;
                            font-size: 16px;
                        }
                    }
                    .cancel-img{
                        position: absolute;
                        right: 10px;
                        cursor: pointer;
                    }
                }
                .verify-code{
                    margin-bottom: 50px;
                    .group{
                        position: relative;
                        display: flex;
                        align-items: center;
                        input{
                            width: 178px;
                            margin-right: 12px;
                            font-size: 16px;
                            // height: 16px;
                            
                        }
                        .border-button-black{
                            width: 118px;
                            height: 18px;
                            line-height: 19px;
                        }
                        .count-down-btn{
                            cursor: pointer;
                            width: 118px;
                            height: 48px;
                            border-radius: 8px;
                            background-color: #fff9f1;
                            color: #eb7859;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 500;
                        }
                    }
                }
                .default-button{
                    border-radius: 8px;
                    height: 48px;
                }
                .private{
                    display: block;
                    text-align: center;
                    margin-top: 16px;
                    margin-bottom: 6px;
                    font-size: 12px;
                    font-weight: 300;
                    color: #676362;
                    margin-bottom: 34px;
                    a{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/login/loginComp.vue